import React from 'react';
import Tag from '../../../../components/Display/Tag';
import moment from 'moment';
import { getConstant } from '../../../../utils/constants';
import styles from "../../cards.module.scss"
function EventItem({ event, handleClickEvent, layout }) {
  return (
    <div
      className={`${styles.projectCard} ${layout === "grid" ? styles.projectCardGrid : ''}`}
      onClick={handleClickEvent || undefined}>
      <div className={styles.contentContainer}>
        <div className={styles.topInfo}>
          <p className={styles.title}>{event.title}</p>
          <span className={styles.subtitle}>{event.place}</span>

          <span className={styles.subtitle}>
            {moment(event.start_dt).format('lll')}

            {' - '}
            {moment(event.end_dt).format('lll')}
          </span>
        </div>
        <div className={styles.tagList}>
          <Tag
            tag={{
              label: getConstant('solarys.formatList', event.format).label,
              bgColor: 'bg-blue-500'
            }}
          />
          {event.public_list.map((o, key) => (
            <Tag
              key={key}
              tag={{
                label: o.label,
                bgColor: 'bg-yellow-500'
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default EventItem;
